const topics = [
  { name: '红桃视频', tag: '热门', count: '12.5万', icon: 'ri-heart-pulse-line' },
  { name: '小蓝视频', tag: '新番', count: '9.8万', icon: 'ri-magic-line' },
  { name: '黑桃视频', tag: '经典', count: '8.3万', icon: 'ri-sparkling-line' },
  { name: '91视频', tag: '日更', count: '15.2万', icon: 'ri-fire-line' },
  { name: '97视频', tag: '高画质', count: '7.6万', icon: 'ri-4k-line' },
  { name: '久久视频', tag: '连载', count: '6.9万', icon: 'ri-time-line' },
  { name: '梅花视频', tag: '推荐', count: '5.4万', icon: 'ri-flower-line' },
  { name: '白桃视频', tag: '人气', count: '4.8万', icon: 'ri-sun-line' },
  { name: '绿萝视频', tag: '上新', count: '3.9万', icon: 'ri-leaf-line' },
  { name: '橙子视频', tag: '精选', count: '3.2万', icon: 'ri-contrast-drop-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="relative py-14 md:py-20 bg-background-900/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-accent-400 font-medium tracking-wider uppercase mb-2">Hot Topics</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">探索当下最受关注的数字颜色系列频道，每日更新热度排行</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="group relative bg-background-800/50 hover:bg-background-700/60 rounded-lg p-4 md:p-5 border border-background-700/40 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 transition-colors duration-300">
                  <i className={`${topic.icon} text-base`}></i>
                </div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400 font-medium whitespace-nowrap">{topic.tag}</span>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-200 group-hover:text-foreground-50 transition-colors duration-200 mb-1">{topic.name}</h3>
              <p className="text-xs text-foreground-600 flex items-center gap-1">
                <i className="ri-eye-line text-[10px]"></i>
                {topic.count} 次观看
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}